// Converted to lazy loading
const customersIndex = () => import('@/pages/sales/customers/index.vue')
const customersForm = () => import('@/pages/sales/customers/form.vue')
const customersShow = () => import('@/pages/sales/customers/show.vue')

const invoicesIndex = () => import('@/pages/sales/invoices/index.vue')
const invoicesForm = () => import('@/pages/sales/invoices/form.vue')
const invoicesShow = () => import('@/pages/sales/invoices/show.vue')
const ordersIndex = () => import('@/pages/sales/orders/index.vue')
const ordersForm = () => import('@/pages/sales/orders/form.vue')
const ordersShow = () => import('@/pages/sales/orders/show.vue')

const saleReturnsIndex = () => import('@/pages/sales/saleReturns/index.vue')
const saleReturnsForm = () => import('@/pages/sales/saleReturns/form.vue')
const saleReturnsShow = () => import('@/pages/sales/saleReturns/show.vue')
const QuotationsIndex = () => import('@/pages/sales/Quotations/index.vue')
const QuotationsForm = () => import('@/pages/sales/Quotations/form.vue')
const QuotationsShow = () => import('@/pages/sales/Quotations/show.vue')

const routes = [
  // customers routes
  {
    path: 'customers',
    name: 'customers',
    component: customersIndex
  },
  {
    path: 'customers/create',
    name: 'customersCreate',
    component: customersForm
  },
  {
    path: 'customers/:id/edit',
    name: 'customersEdit',
    component: customersForm
  },

  {
    path: 'customers/:id',
    name: 'customersShow',
    component: customersShow
  },
  //quotations routs
  {
    path: 'quotations',
    name: 'quotations',
    component: QuotationsIndex
  },
  {
    path: 'quotations/create',
    name: 'quotationsCreate',
    component: QuotationsForm
  },
  {
    path: 'quotations/:id/edit',
    name: 'quotationsEdit',
    component: QuotationsForm
  },
  {
    path: 'quotations/:id',
    name: 'quotationsShow',
    component: QuotationsShow
  },

  //invoice routs
  {
    path: 'invoices',
    name: 'invoices',
    component: invoicesIndex
  },
  {
    path: 'invoices/create',
    name: 'invoicesCreate',
    component: invoicesForm
  },
  {
    path: 'invoices/:id/edit',
    name: 'invoicesEdit',
    component: invoicesForm
  },
  {
    path: 'invoices/:id',
    name: 'invoicesShow',
    component: invoicesShow
  },
  {
    path: 'orders',
    name: 'orders',
    component: ordersIndex
  },
  {
    path: 'orders/create',
    name: 'ordersCreate',
    component: ordersForm
  },
  {
    path: 'orders/:id/edit',
    name: 'ordersEdit',
    component: ordersForm
  },
  {
    path: 'orders/:id',
    name: 'ordersShow',
    component: ordersShow
  },

  //saleReturns routs
  {
    path: 'saleReturns',
    name: 'saleReturns',
    component: saleReturnsIndex
  },
  {
    path: 'saleReturns/create',
    name: 'saleReturnsCreate',
    component: saleReturnsForm
  },

  {
    path: 'saleReturns/:id/edit',
    name: 'saleReturnsEdit',
    component: saleReturnsForm
  },
  {
    path: 'saleReturns/:id',
    name: 'saleReturnsShow',
    component: saleReturnsShow
  }
]

export default routes
